export const ClockSVG = () => {
  return (
    <svg
      className="scale-125"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 12C4.5 16.1353 7.86467 19.5 12 19.5C16.1353 19.5 19.5 16.1353 19.5 12C19.5 7.86467 16.1353 4.5 12 4.5C7.86467 4.5 4.5 7.86467 4.5 12ZM5.5 12C5.5 8.416 8.416 5.5 12 5.5C15.584 5.5 18.5 8.416 18.5 12C18.5 15.584 15.584 18.5 12 18.5C8.416 18.5 5.5 15.584 5.5 12ZM14.7713 15.4787C14.8653 15.5733 14.9913 15.6253 15.1247 15.6253C15.258 15.6253 15.384 15.572 15.4787 15.478C15.5733 15.384 15.6253 15.258 15.6253 15.1247C15.6253 14.9913 15.5733 14.866 15.4787 14.7713L12.5007 11.7927V9.5C12.5007 9.224 12.2767 9 12.0007 9C11.7247 9 11.5007 9.224 11.5007 9.5V12C11.5007 12.0587 11.5107 12.116 11.532 12.1733L11.538 12.19C11.5633 12.252 11.6 12.3067 11.6467 12.3533L14.7713 15.4787Z"
        fill="#3C4D6A"
      />
    </svg>
  );
};
